export default __webpack_public_path__ + "static/media/aira_4.1bc74f5d.PNG";